
import Utility, { getCapitalized, toCurrencyFormat } from "../utility/Utility";
import { TableManger, COLUMN_CODE, TABLES } from "../managers/TableManger";
import AppManager from "../managers/AppManager";
import { CONSTANTS, INPUT_TYPE } from "../constants/Constant"
import ActivityManager from "../components/activity/ActivityManager";
import { FILTER_LOGICAL_OPERATORS, FILTER_OPERATORS } from "../constants/Enums";
import { isEmpty } from "../components/import_export/utility/ImportUtility";

class TableDataParser {
  static parseTableData(data) {
    let tableData = {};
    tableData["id"] = data?._id;
    tableData["name"] = data?.name;
    tableData["columns"] = this.parseColumnData(data?.columnsMetaData);
    return tableData;
  }
  static parseColumnData(data) {
    let columnsData = [];
    data.forEach((column) => {
      let data = { ...column };
      data["key"] = column.id;
      data["type"] = column.type.toLowerCase();
      data["options"] = column.options ? column.options : [];
      data["required"] = column.required ? column.required : false;
      data["width"] = column.width ? column.width : 200;
      data["name"] = this.changeColumnHeader(column.name);
      columnsData.push(data);
    });
    return columnsData;
  }

  static changeColumnHeader(columnName) {
    switch(columnName){
      case CONSTANTS.BASIC_SALARY :
        return CONSTANTS.CTC
      case CONSTANTS.SEGMENT : 
        return CONSTANTS.JOB_OPENING
      default :
        return columnName  
    }
  }

  static parseRowData(data, table = null) {
    return data.map((row) => {
      this.checkAndReplaceDirectLink(row, table); // TODO - Need to remove this @Piyush this is a workaround
      return { ...row.cells, id: row._id };
    });
  }
  static getColumnToAdd(column) {
    return {
      name: column.name,
      type: column.type,
      options: column.options || [],
      required: column.required || false,
      width: column.width || 200,
      editable: !isEmpty(column.editable) ? column.editable : true,
      hidden: column.hidden || false,
      systemField: column.systemField || false,
      uiVisible: column.uiVisible || true,
    };
  }
  static getRowToAdd(rowData) {
    let cells = {};
    for (let key in rowData) {
      cells[key] = rowData[key].value;
    }
    return { cells };
  }

  static checkAndReplaceDirectLink(row, table) {
    if (table !== null) {
      const column_id = TableManger.getColumnId(
        table,
        COLUMN_CODE.JOB_FORMS.DIRECT_LINK
      );
      row.cells[column_id] = AppManager.generateDirectLink(
        row.cells[column_id]
      );
    }
  }
  static checkAndReplaceSegment() {
    const contactSegmentCol = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOBOPENING
    );
    let segmentData = {
      type: contactSegmentCol.type,
      options: contactSegmentCol.options,
      name: contactSegmentCol.name,
    };
    TableManger.updateColumn(COLUMN_CODE.JOB_FORMS.SEGMENT_ID, TABLES.JOB_FORMS, {
      ...TableManger.getColumn(TABLES.JOB_FORMS, COLUMN_CODE.JOB_FORMS.SEGMENT_ID),
      ...segmentData,
    });
    TableManger.updateColumn(COLUMN_CODE.CAMPAIGN.SEGMENT_ID, TABLES.CAMPAIGN, {
      ...TableManger.getColumn(
        TABLES.CAMPAIGN,
        COLUMN_CODE.CAMPAIGN.SEGMENT_ID
      ),
      ...segmentData,
    });
  }
   /**
   * @description
   * This method creates groupings for filter payload, to apply logical operations on conditions.
   * External conditions (module level) are always processed with "AND" operators,
   * while GridLevel/additional Filters are processed with user selected operator.
   */
    static getModifiedFilterPayload(
      payload,
      columns,
      splitOnExternalConditions = true
    ) {
      const { logicalOperator, conditions } = payload;
      if (!conditions?.length)
        return { conditions: [], logicalOperator: logicalOperator };
  
      let filter1, filter2;
  
      if (splitOnExternalConditions) {
        filter1 = TableDataParser.getModifiedFilterPayload(
          {
            conditions: conditions.filter((condition) => condition.isExternal),
            logicalOperator: FILTER_LOGICAL_OPERATORS.AND
          },
          columns,
          false
        );
        filter2 = TableDataParser.getModifiedFilterPayload(
          {
            conditions: conditions.filter((condition) => !condition.isExternal),
            logicalOperator
          },
          columns,
          false
        );
      } else {
        filter1 = TableDataParser.updateFilterConditionForPayload(
          conditions[0],
          columns
        );
        filter2 =
          conditions?.length > 2
            ? TableDataParser.getModifiedFilterPayload(
                {
                  conditions: conditions.slice(1),
                  logicalOperator
                },
                columns,
                false
              )
            : TableDataParser.updateFilterConditionForPayload(
                conditions[1],
                columns
              );
      }
  
      return {
        filter1,
        filter2,
        logicalOperator: splitOnExternalConditions
          ? FILTER_LOGICAL_OPERATORS.AND
          : logicalOperator,
      };
    }
    /**
   * @description
   * This method modifies the filter condition based on DATE or COLUMN CODES
   * (for handling equalTo & greater than operations)
   */
  static updateFilterConditionForPayload(filterCondition, columns) {
    const updatedFilterConditions = [];
    const columnData = columns?.find(
      (column) => column.id === filterCondition?.colId
    );

    if (!Utility.isEmptyObject(filterCondition)) {
      filterCondition = { ...filterCondition };
      delete filterCondition.isExternal;
    }

    if (
      columnData?.type !== INPUT_TYPE.DATE ||
      !Utility.isValidDate(filterCondition.value)
    ) {
      
      if (!Utility.isEmptyObject(filterCondition)) {
         updatedFilterConditions.push(filterCondition);
      }

      return {
        conditions: updatedFilterConditions,
        logicalOperator: FILTER_LOGICAL_OPERATORS.AND,
      };
    }

    const selectedDate = new Date(filterCondition.value);
    const nextDate = new Date(
      new Date(selectedDate).setDate(selectedDate.getDate() + 1)
    );
    if (filterCondition.opr === FILTER_OPERATORS.EQUAL) {
      updatedFilterConditions.push({
        colId: filterCondition.colId,
        value: selectedDate,
        opr: FILTER_OPERATORS.GREATER_THAN_OR_EQUAL,
      });

      updatedFilterConditions.push({
        colId: filterCondition.colId,
        value: nextDate,
        opr: FILTER_OPERATORS.LESS_THAN,
      });
    } else if (filterCondition.opr === FILTER_OPERATORS.GREATER_THAN) {
      updatedFilterConditions.push({
        colId: filterCondition.colId,
        value: nextDate,
        opr: FILTER_OPERATORS.GREATER_THAN_OR_EQUAL,
      });
    } else {
      updatedFilterConditions.push(filterCondition);
    }

    return {
      conditions: updatedFilterConditions,
      logicalOperator: FILTER_LOGICAL_OPERATORS.AND,
    };
  }
}

export default TableDataParser;
